<div *ngIf="showModal" class="modal-backdrop-custom">
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
        <div class="modal-content">

            <div class="modal-header custommodal-header py-2 d-flex justify-content-between align-items-center">
                <h1 class="modal-title modalTitle mb-0" style="padding-left: 10px;">
                    STORE(S) LIST IN HAWAII STATE (Count: {{stores?.length}})
                </h1>
                <button type="button" class="btn-close" aria-label="Close" (click)="onClose()" style="padding-right: 20px;"></button>
            </div>

            <div class="modal-body pb-2">
                <div class="table-responsive tableFixHead">
                    <table class="table datatable border-x-0 mb-4">
                        <thead>
                            <tr class="subheaderrr">
                                <th class="py-1" width="8%">STORE #</th>
                                <th class="py-1" width="10%">TDLINX</th>
                                <th class="py-1" width="20%">Store Name</th>
                                <th class="py-1" width="20%">Street</th>
                                <th class="py-1" width="15%">City</th>
                                <th class="py-1" width="10%">State</th>
                                <th class="py-1" width="10%">Zip</th>
                                <!-- <th width="10%" class="border-end-0">Status</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of stores">
                                <td class="table-row">{{item.storeNumber}}</td>
                                <td class="table-row">{{item.tdlinx}}</td>
                                <td class="table-row">{{item.storeName}}</td>
                                <td class="table-row">{{item.street}}</td>
                                <td class="table-row">{{item.city}}</td>
                                <td class="table-row">{{item.state}}</td>
                                <td class="table-row">{{item.zip}}</td>
                                <!-- <td class="table-row">
                                    {{ item.status == 1 ? 'Invalid' : (item.status == 2 ? 'Active' : 'Inactive') }}
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="mt-3" *ngIf="!isNewProject">
                    <div class="d-flex justify-content-end">
                        <div class="button-container d-flex">
                            <div #saveDiv class="me-1 position-relative actionButton align-self-center dropdown-toggle"
                                data-bs-toggle="dropdown" aria-expanded="false" (click)="onSaveAndNotify()">
                                <img src="assets/images/save_icon.svg" class="saveImg me-2" alt="" title="Save">
                                <span class="statusValue pe-2">NOTIFY ISO ADMIN</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>